import { DndList } from '@design-system/components/dndList/DndList';
import { extrasVM } from '../Extras.page';
import { ExtrasItemRenderer } from './ExtrasItemRenderer';
import { _noop } from '@client/new/helpers/general';
import { ExtrasPreview } from './ExtrasPreview';
import { Row } from '@design-system/components/grid/grid';
import {
  grid,
  gridNoPreview,
  contentWrapper,
  mobileScrollContainer,
} from './ExtrasContent.css';
import { ExtrasListHeader } from './ExtrasListHeader';
import {
  DndParent,
  DnDItem,
} from '@design-system/components/dndList/DndList.utils';
import { useBreakpoints } from '@design-system/breakpointsStore';
import { ExtrasNoResults } from './ExtrasNoResults';

export const ExtrasContent = () => {
  const vm = extrasVM.useValue();
  const { mobile } = useBreakpoints();

  if (vm.isExtrasEmpty) return null;

  if (vm.isFilteredResultsEmpty) return <ExtrasNoResults />;

  const showPreview = vm.showPreview && !mobile;

  return (
    <Row className={showPreview ? grid : gridNoPreview}>
      <div className={mobile ? contentWrapper : undefined}>
        <div className={mobile ? mobileScrollContainer : undefined}>
          {!mobile && <ExtrasListHeader />}
          <DndList
            items={
              ((vm.filteredContentIds.items || [])[0]?.items ?? []) as Array<
                DndParent<DnDItem>
              >
            }
            onChange={(d) => vm.dispatch('Reorder', d)}
            renderParent={ExtrasItemRenderer}
            renderChild={_noop}
          />
        </div>
      </div>
      {showPreview && (
        <div>
          <ExtrasPreview />
        </div>
      )}
    </Row>
  );
};
